import axios from 'axios';

export const api = axios.create({
  validateStatus: function (status) {
    return status >= 200 && status < 300; // default
  },
  baseURL: 'https://subscriptions-prd-api-web.azurewebsites.net/api/subscriber/preference-center'
})

